import $ from 'jquery';

$('.navbar__search-toggle').on('click', function() {
    $('.searchbox__wrap').addClass('searchbox__wrap--visible');
});

$('.searchbox__close').on('click', function() {
    $('.searchbox__wrap').removeClass('searchbox__wrap--visible');
});
